import styled from 'styled-components';

const Name = styled.h4`
  font-family: ${Styles.fontFamily.body};
  margin: 0;
  margin-top: 0.25rem;
  padding: 0;
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 1.3;
  font-size: 0.9375rem;
  text-overflow: ellipsis;
  overflow: hidden;

  ${Styles.mobileTiny`
    max-width: 107px;
  `}
  ${Styles.desktop`
    font-size: 1.125rem;
    height: 1.375rem;
    margin: 0;
  `}
`;

export default Name;
